import React, { useEffect, useRef, useState } from "react";
import styles from "../../styles/profile.module.css";
import { Modal } from "react-bootstrap";
import { Form, Formik } from "formik";
import { errorContainer, formAttr } from "../common/CommonFun";
import { PostTokenApi } from "../../api/api-service";
import { API_Path } from "../../const";
import * as Yup from "yup";
import usePageTitle from "../customHook/usePageTitle";
import { toast } from "react-toastify";

export default function LoginPasswordInfo(props) {
    usePageTitle("User Account", true);
    const intervalRef = useRef();
    const [verifyCode, setVerifyCode] = useState();
    const [loading, setLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnPassLoading, setBtnPassLoading] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [timeLeft, setTimeLeft] = useState(30);
    const [passVisible, setPassVisible] = useState({
        currentShow: false,
        newShow: false,
        confirmShow: false,
    });

    useEffect(() => {
        if (isVisible) {
            intervalRef.current = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
            return () => clearInterval(intervalRef.current); // Clean up the interval on unmount or time change
        }
    }, [isVisible]);

    useEffect(() => {
        if (timeLeft <= 0) clearInterval(intervalRef.current);
    }, [timeLeft]);

    const formattedTime = String(timeLeft).padStart(2, "0");

    const handleCloseChangePassModal = () => setShowChangePasswordModal(false);

    const handleToggle = (field) => {
        setPassVisible((prevState) => ({
            ...prevState,
            [`${field}Show`]: !prevState[`${field}Show`],
        }));
    };

    const UserPasswordrequest = () => {
        setBtnLoading(true);
        let editProfile = new Promise((resolve) => {
            resolve(PostTokenApi(API_Path.userPasswordRequest));
        });
        editProfile.then((res) => {
            if (res.data.Isvalid) {
                setIsVisible(true);
                setTimeLeft(30);
                toast.success(res.data.Successes[0]);
            } else toast.error(res.data.Errors[0]);
        });
        setTimeout(() => {
            setBtnLoading(false);
            setIsVisible(false);
        }, 30100);
    };
    const handleShowChangePasswordModal = () => {
        props.handleClose();
        setShowChangePasswordModal(true);
    };

    const setSubmitData = (formdata, resetForm) => {
        setLoading(true);
        let currentPasswordVerify = new Promise((resolve) => {
            resolve(PostTokenApi(API_Path.userPasswordVerify, { ...formdata }));
        });
        currentPasswordVerify.then((res) => {
            if (res.data.Isvalid) {
                toast.success(res.data.Successes[0]);
                setVerifyCode(formdata.VerifyCode);
                handleShowChangePasswordModal();
                resetForm();
            } else toast.error(res.data.Errors[0]);
            setLoading(false);
        });
    };

    const setSubmitPasswordData = (formdata, resetForm) => {
        setBtnPassLoading(true);
        let data = {
            ...formdata,
            VerifyCode: verifyCode,
        };
        let currentUserPassword = new Promise((resolve) => {
            resolve(PostTokenApi(API_Path.updateUserPassword, data));
        });
        currentUserPassword.then((res) => {
            if (res.data.Isvalid) {
                handleCloseChangePassModal();
                window.location.href = "/login";
                resetForm();
                localStorage.removeItem("BasketAuthorizationData");
                toast.success(res.data.Successes[0]);
            } else toast.error(res.data.Errors[0]);
            setBtnPassLoading(false);
        });
    };

    return (
        <>
            <Modal show={props.showModal} centered className={styles.verify_mail_modal}>
                <Modal.Header className={`${styles.auth_modal_head} `}>
                    <Modal.Title className={`${styles.auth_modal_title}`}>Change password</Modal.Title>
                    <div
                        onClick={() => {
                            props.handleClose();
                            setBtnLoading(false);
                            setIsVisible(false);
                        }}
                        className={styles.close_modal_icon}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </div>
                </Modal.Header>

                <Modal.Body className={styles.resend_verify_mail_body}>
                    <p>For your security, we will send a verification OTP to registered e-mail Address.</p>
                    <Formik
                        initialValues={{ VerifyCode: "" }}
                        validationSchema={Yup.object().shape({
                            VerifyCode: Yup.string().required("Verification OTP is required."),
                        })}
                        onSubmit={(values, { resetForm }) => {
                            setSubmitData(values, resetForm);
                        }}
                    >
                        {(runform) => {
                            const { touched, errors } = runform;
                            return (
                                <Form onSubmit={runform.handleSubmit}>
                                    <div className={`${styles.inputWidth} mb-3 w-auto`}>
                                        <div className="d-block position-relative">
                                            <label>
                                                Verification OTP
                                                <span className={styles.asterisk}>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="VerifyCode"
                                                {...formAttr(runform, "VerifyCode")}
                                                placeholder="Enter verification OTP"
                                                className={`${styles.form_input} ${errors.VerifyCode && touched.VerifyCode ? "input-error" : ""} `}
                                                maxLength={6}
                                            />
                                            {isVisible ? (
                                                <button type="button" className={`${styles.auth_login_btn} cursor-not-allowed`}>
                                                    00:{formattedTime}
                                                </button>
                                            ) : (
                                                <button type="button" className={styles.auth_login_btn} onClick={UserPasswordrequest} disabled={btnLoading}>
                                                    Send Code
                                                    {btnLoading && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                                </button>
                                            )}
                                        </div>
                                        <div className="otp-timer">{errorContainer(runform, "VerifyCode")}</div>
                                    </div>
                                    <div className="form-group">
                                        <div className={`${styles.personal_info_btn} text-center d-flex p-0`}>
                                            <button type="button" className={`${styles.button} ${styles.button_border}`} onClick={() => runform.resetForm()}>
                                                Clear
                                            </button>
                                            <button type="submit" className={`${styles.button} primary_button`} disabled={loading}>
                                                Enable
                                                {loading && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                </Modal.Body>
            </Modal>

            <Modal show={showChangePasswordModal} centered className={styles.verify_mail_modal}>
                <Modal.Header className="pb-0">
                    <Modal.Title>Change Password</Modal.Title>
                    <div onClick={handleCloseChangePassModal} className={styles.close_modal_icon}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </div>
                </Modal.Header>

                <Modal.Body className={styles.resend_verify_mail_body}>
                    <div>
                        <Formik
                            initialValues={{
                                CurrentPassword: "",
                                NewPassword: "",
                                ConfirmNewPassword: "",
                            }}
                            validationSchema={Yup.object().shape({
                                CurrentPassword: Yup.string().required("Current password is required."),
                                NewPassword: Yup.string()
                                    .required("New password is required.")
                                    .matches(
                                        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&_^#])[A-Za-z\d@$!%*?&_^#]{8,20}$/,
                                        "Password must contain at least one number, one uppercase letter, one lowercase letter and one symbol i.e. @, $, !, %, *, &, _, #, ^ etc. Password length should be 8 to 16 characters."
                                    )
                                    .test("passwords-match", "Current password and new password do match", function (value) {
                                        return this.parent.CurrentPassword != value;
                                    }),
                                ConfirmNewPassword: Yup.string()
                                    .required("Confirm new password is required.")
                                    .test("passwords-match", "Confirm new password does not match.", function (value) {
                                        return this.parent.NewPassword === value;
                                    }),
                            })}
                            onSubmit={(values, { resetForm }) => {
                                setSubmitPasswordData(values, resetForm);
                            }}
                        >
                            {(runform) => {
                                const { touched, errors } = runform;
                                return (
                                    <Form onSubmit={runform.handleSubmit}>
                                        <div className={`${styles.personalinfo_width} d-block`}>
                                            <div className={`${styles.personalinfocontent} w-100`}>
                                                <label>
                                                    Current Password <span className={styles.asterisk}>*</span>
                                                </label>
                                                <div className="d-block position-relative">
                                                    <input
                                                        type={passVisible.currentShow ? "text" : "password"}
                                                        placeholder="Enter current password"
                                                        name="CurrentPassword"
                                                        className={`${styles.form_input} ${errors.CurrentPassword && touched.CurrentPassword ? "input-error" : ""} `}
                                                        maxLength={16}
                                                        {...formAttr(runform, "CurrentPassword")}
                                                    />
                                                    <span className={styles.login_input_icon} onClick={() => handleToggle("current")}>
                                                        {passVisible.currentShow ? (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                                                <path
                                                                    d="M6.24984 17.4999C8.78114 17.4999 10.8332 15.4479 10.8332 12.9166C10.8332 10.3853 8.78114 8.33325 6.24984 8.33325C3.71853 8.33325 1.6665 10.3853 1.6665 12.9166C1.6665 15.4479 3.71853 17.4999 6.24984 17.4999Z"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path d="M17.5 1.66675L15.1667 4.00008M9.5 9.66675L13.6667 5.50008" stroke="#404040" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path
                                                                    d="M12.9165 6.24992L15.4165 8.74992L18.3332 5.83325L15.8332 3.33325"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        ) : (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                                                <path
                                                                    d="M8.54167 9.16675H7.08333H4.16667C3.24619 9.16675 2.5 9.91294 2.5 10.8334V16.6667C2.5 17.5872 3.24619 18.3334 4.16667 18.3334H15.8333C16.7538 18.3334 17.5 17.5872 17.5 16.6667V10.8334C17.5 9.91294 16.7538 9.16675 15.8333 9.16675H12.9167H11.4583"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path
                                                                    d="M5.83301 9.16675V5.83341C5.83301 4.72835 6.27199 3.66854 7.0534 2.88714C7.8348 2.10573 8.89461 1.66675 9.99967 1.66675C11.1047 1.66675 12.1646 2.10573 12.946 2.88714C13.7274 3.66854 14.1663 4.72835 14.1663 5.83341V9.16675"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        )}
                                                    </span>
                                                </div>
                                                {errorContainer(runform, "CurrentPassword")}
                                            </div>
                                            <div className={`${styles.personalinfocontent} w-100`}>
                                                <label>
                                                    New Password <span className={styles.asterisk}>*</span>
                                                </label>
                                                <div className="d-block position-relative">
                                                    <input
                                                        type={passVisible.newShow ? "text" : "password"}
                                                        placeholder="Enter new password"
                                                        name="NewPassword"
                                                        className={`${styles.form_input} ${errors.NewPassword && touched.NewPassword ? "input-error" : ""} `}
                                                        maxLength={16}
                                                        {...formAttr(runform, "NewPassword")}
                                                    />
                                                    <span className={styles.login_input_icon} onClick={() => handleToggle("new")}>
                                                        {passVisible.newShow ? (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                                                <path
                                                                    d="M6.24984 17.4999C8.78114 17.4999 10.8332 15.4479 10.8332 12.9166C10.8332 10.3853 8.78114 8.33325 6.24984 8.33325C3.71853 8.33325 1.6665 10.3853 1.6665 12.9166C1.6665 15.4479 3.71853 17.4999 6.24984 17.4999Z"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path d="M17.5 1.66675L15.1667 4.00008M9.5 9.66675L13.6667 5.50008" stroke="#404040" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path
                                                                    d="M12.9165 6.24992L15.4165 8.74992L18.3332 5.83325L15.8332 3.33325"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        ) : (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                                                <path
                                                                    d="M8.54167 9.16675H7.08333H4.16667C3.24619 9.16675 2.5 9.91294 2.5 10.8334V16.6667C2.5 17.5872 3.24619 18.3334 4.16667 18.3334H15.8333C16.7538 18.3334 17.5 17.5872 17.5 16.6667V10.8334C17.5 9.91294 16.7538 9.16675 15.8333 9.16675H12.9167H11.4583"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path
                                                                    d="M5.83301 9.16675V5.83341C5.83301 4.72835 6.27199 3.66854 7.0534 2.88714C7.8348 2.10573 8.89461 1.66675 9.99967 1.66675C11.1047 1.66675 12.1646 2.10573 12.946 2.88714C13.7274 3.66854 14.1663 4.72835 14.1663 5.83341V9.16675"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        )}
                                                    </span>
                                                </div>
                                                {errorContainer(runform, "NewPassword")}
                                            </div>
                                            <div className={`${styles.personalinfocontent} w-100`}>
                                                <label>
                                                    Confirm New Password <span className={styles.asterisk}>*</span>
                                                </label>
                                                <div className="d-block position-relative">
                                                    <input
                                                        type={passVisible.confirmShow ? "text" : "password"}
                                                        placeholder="Enter confirm new password"
                                                        name="ConfirmNewPassword"
                                                        className={`${styles.form_input} ${errors.ConfirmNewPassword && touched.ConfirmNewPassword ? "input-error" : ""} `}
                                                        maxLength={16}
                                                        {...formAttr(runform, "ConfirmNewPassword")}
                                                    />
                                                    <span className={styles.login_input_icon} onClick={() => handleToggle("confirm")}>
                                                        {passVisible.confirmShow ? (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                                                <path
                                                                    d="M6.24984 17.4999C8.78114 17.4999 10.8332 15.4479 10.8332 12.9166C10.8332 10.3853 8.78114 8.33325 6.24984 8.33325C3.71853 8.33325 1.6665 10.3853 1.6665 12.9166C1.6665 15.4479 3.71853 17.4999 6.24984 17.4999Z"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path d="M17.5 1.66675L15.1667 4.00008M9.5 9.66675L13.6667 5.50008" stroke="#404040" strokeLinecap="round" strokeLinejoin="round" />
                                                                <path
                                                                    d="M12.9165 6.24992L15.4165 8.74992L18.3332 5.83325L15.8332 3.33325"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        ) : (
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                                                <path
                                                                    d="M8.54167 9.16675H7.08333H4.16667C3.24619 9.16675 2.5 9.91294 2.5 10.8334V16.6667C2.5 17.5872 3.24619 18.3334 4.16667 18.3334H15.8333C16.7538 18.3334 17.5 17.5872 17.5 16.6667V10.8334C17.5 9.91294 16.7538 9.16675 15.8333 9.16675H12.9167H11.4583"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                                <path
                                                                    d="M5.83301 9.16675V5.83341C5.83301 4.72835 6.27199 3.66854 7.0534 2.88714C7.8348 2.10573 8.89461 1.66675 9.99967 1.66675C11.1047 1.66675 12.1646 2.10573 12.946 2.88714C13.7274 3.66854 14.1663 4.72835 14.1663 5.83341V9.16675"
                                                                    stroke="#404040"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                />
                                                            </svg>
                                                        )}
                                                    </span>
                                                </div>
                                                {errorContainer(runform, "ConfirmNewPassword")}
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className={`${styles.personal_info_btn} text-center d-flex py-4`}>
                                                <button type="button" className={`${styles.button} ${styles.button_border}`} onClick={() => runform.resetForm()}>
                                                    Clear
                                                </button>
                                                <button type="submit" className={`${styles.button} primary_button`} disabled={btnPassLoading}>
                                                    Save
                                                    {btnPassLoading && <span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span>}
                                                </button>
                                            </div>
                                        </div>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
